import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import classNames from 'classnames';
import { NavLink } from "react-router-dom";
import { useCurrentUser } from "../../utils/CurrentUserContext";


const ProfileMenu = ({userNavigation}) => {
  const {user} = useCurrentUser();

  if (!user) return null;

  return (
    <Menu as="div" className="flex-shrink-0 relative ml-5">
      <div>
        <Menu.Button className="bg-white rounded-full flex focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rose-500">
          <span className="sr-only">Open user menu</span>
          <img className="h-8 w-8 rounded-full" src={user.avatarUrl} alt="" />
        </Menu.Button>
      </div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="origin-top-right absolute z-10 right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 py-1 focus:outline-none">
          {userNavigation.map(({name, ...props}) => (
            <Menu.Item key={name}>
              <NavLink
                {...props}
                className={({ isActive }) => classNames(
                  "block py-2 px-4 text-sm text-gray-700 hover:bg-gray-50",
                  { "bg-gray-200 hover:bg-gray-200": props.to && isActive },
                )}
              >
                {name}
              </NavLink>
            </Menu.Item>
          ))}
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default ProfileMenu;
